<bmcore-color-block-header [groupTitle]="group.title" [currentGroupTitle]="currentGroupTitle">
</bmcore-color-block-header>

@if (group.title === currentGroupTitle) {
  <div class="manage-block__box" (click)="$event.stopPropagation()">
    <!-- Beat sorting block -->
    @if (group.title === lg.colorCustomizer.manageBlock.beatSorting) {
      <bmcore-rating-tracks-select></bmcore-rating-tracks-select>
    }
    <!-- Upload block -->
    @if (group.title === lg.colorCustomizer.manageBlock.bgImages) {
      @for (uploadItem of uploadData; track uploadItem; let index = $index; let count = $count) {
        <bmcore-upload-block [uploadItem]="uploadItem" [uploadItemIndex]="index" [uploadItemLength]="count">
        </bmcore-upload-block>
      }
    }
    <!-- Social network  -->
    @if (group.title === lg.colorCustomizer.manageBlock.socMedia) {
      @for (socContact of socContacts; track socContact; let index = $index; let count = $count) {
        <bmcore-soc-media-block
          [socContact]="socContact"
          [socContactIndex]="index"
          [socContactsLength]="count"
          (updateContactsEvent)="updateContactsEvent.emit($event)"
          [contactsResultMessage]="contactsResultMessage"
        >
        </bmcore-soc-media-block>
      }
    }
  </div>
}
